module.exports = __webpack_public_path__ + "img/misja-brief@mob.54d6275b.png";